// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"fb22a48f","197":"fb22a48f","215":"fb22a48f","234":"fb22a48f","320":"fb22a48f","927":"fb22a48f"}[chunkId] + ".chunk.css";
};